module.exports = __webpack_public_path__ + "img/rotateHint.21b421cb.png";